var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReductionOfLanesCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.3;}\r\n\t.st1{fill:#1D1D1B;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,8) scale(0.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 6.6,
    className: "st0",
    width: 49.7,
    height: 70.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.8,9.4v64.4c0,0.8,0.3,1.5,0.9,2.1c0.5,0.5,1.3,0.9,2.1,0.9h43.9c0.8,0,1.5-0.3,2.1-0.9 c0.5-0.5,0.9-1.3,0.9-2.1V9.4c0-0.8-0.3-1.5-0.9-2.1c-0.5-0.5-1.3-0.9-2.1-0.9H17.7c-0.8,0-1.5,0.3-2.1,0.9 C15.1,7.9,14.8,8.7,14.8,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.3,9.4v64.4c0,0.8,0.7,1.5,1.5,1.5h43.9c0.8,0,1.5-0.7,1.5-1.5V9.4c0-0.8-0.7-1.5-1.5-1.5H17.7 C16.9,8,16.3,8.6,16.3,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,38.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.8,0.7l-9.2,7c-2.2,2.2-3.4,5.2-3.4,8.3v16.4h-3.5V54.5 c0-3.8,1.4-7.4,3.9-10.2c0.4-0.4,0.8-0.7,1.2-1l8.9-6.7c0.2-0.2,0.4-0.3,0.6-0.5c2-2.2,3.1-5,3.1-7.9v-5.3h-6.1l7.9-10.5l7.9,10.5 h-6.1v48h-3.5v-33C46.6,38,46.4,38.2,46.3,38.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReductionOfLanesCanvas);
export default __webpack_public_path__ + "static/media/reduction-of-lanes-canvas.cc9ee773a93d6e63e985940aa66d8115.svg";
export { ForwardRef as ReactComponent };